export enum AnalyticsEvents {
  LOGIN = 'login',
  SIGN_UP = 'sign_up',
  VIDEO_UPLOADED = 'video_uploaded',
}
